const RESET_STORE = 'RESET_STORE';

export {
    RESET_STORE,
};
